"use client";

import { Link } from "@/components/ui";
import { Title, Button, Subtitle } from "@tremor/react";
import Image from "next/image";
import { useRouter } from "next/navigation";
export default function NotAuthorized({
  message
}: {
  message?: string;
}) {
  const router = useRouter();
  return <div className="flex flex-col items-center justify-center h-full" data-sentry-component="NotAuthorized" data-sentry-source-file="not-authorized.tsx">
      <Title data-sentry-element="Title" data-sentry-source-file="not-authorized.tsx">403 Not Authorized</Title>
      <div className="flex flex-col items-center">
        <Subtitle data-sentry-element="Subtitle" data-sentry-source-file="not-authorized.tsx">
          {message || "You do not have permission to access this page."}
        </Subtitle>
        <Subtitle data-sentry-element="Subtitle" data-sentry-source-file="not-authorized.tsx">
          <br />
          If you need help, please contact us on{" "}
          <Link href="https://slack.keephq.dev/" target="_blank" rel="noopener noreferrer" data-sentry-element="Link" data-sentry-source-file="not-authorized.tsx">
            Slack
          </Link>
        </Subtitle>
      </div>
      <Image src="/keep.svg" alt="Keep" width={150} height={150} data-sentry-element="Image" data-sentry-source-file="not-authorized.tsx" />
      <Button onClick={() => {
      router.back();
    }} color="orange" variant="secondary" data-sentry-element="Button" data-sentry-source-file="not-authorized.tsx">
        Go back
      </Button>
    </div>;
}